export default "__VITE_ASSET__CZQnsDYI__"